module.exports = __webpack_public_path__ + "static/media/female-doctor.f923954b.png";